'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const Icon = {
	base: "O-4rh",
	caret: "dTn1A"
};
const overrides = {
	"alert-success": "-dAlj",
	"alert-info": "wv24z",
	"alert-warning": "BVRVv",
	"alert-danger": "NNvr-",
	fieldLabel: "f38xp",
	button: "f3Z2f",
	buttonSecondary: "QqJXy",
	buttonSecondaryHover: "n73iE",
	dropdownToggle: "zs2jf",
	dropdownMenuLinkDisabled: "z-9ag",
	dropdownToggleIcon: "-ZQTP",
	checkbox: "VaQzy",
	tooltip: "xiKiA"
};

exports.Icon = Icon;
exports.overrides = overrides;
